import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

const SubCategories = () => {

    const { name } = useParams();

    const [subcategories, setSubCategories] = useState([]);

    // Extract subcategories
    useEffect(() => {
        async function fetchSubcategories() {
            const response = await getSubCategories(name)
            setSubCategories(response?.subcategories)
        }

        fetchSubcategories()

    }, [name])

    return (
        <div className='container mt-5 p-3 page-section'>
            <div className='row p-4 minHight'>
                <div className='d-flex justify-content-between align-items-center'>
                    <h4 className='mb-4'>Categories: {name}</h4>
                </div>
                <div className="row mt-3">
                    {subcategories ? (
                        subcategories.map((category) => (
                            <div key={category.id} className="col-lg-2 col-md-4 col-6 mb-lg-4 mb-md-3 mb-3">
                                <Link to={`/category/${name}/${category.name}`} className="card bordercolor py-3 px-4 shadow nav-link rounded-5">
                                    {category.name}
                                </Link>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center">
                            <p>No subcategories available.</p>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}

export default SubCategories

export const getSubCategories = async (name) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}product/subcategories?categoryname=${name}`);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
    }
};